import StatusLegend from "../StatusLegend";

import styles from "./TranscriptStatusExplainer.module.css";

const TranscriptStatusExplainer: React.FunctionComponent<{
  precedingText?: string;
}> = ({ precedingText: precedingText }) => {
  return (
    <div className={styles.transcriptStatusExplainer}>
      {precedingText && <p className={styles.explainerText}>{precedingText}</p>}
      <StatusLegend color="gray" />
      <p className={styles.explainerText}>No transcript</p>
      <StatusLegend color="green" />
      <p className={styles.explainerText}>Success</p>
      <StatusLegend color="yellow" />
      <p className={styles.explainerText}>In progress</p>
      <StatusLegend color="red" />
      <p>Failed</p>
    </div>
  );
};

export default TranscriptStatusExplainer;
